export default {
  siasarApiUrl: 'https://data-api.globalsiasar.org',
  pentaho: {
    baseUrl: 'https://pentaho.globalsiasar.org/pentaho/api/repos/:home:siasar:',
    username: 'siasar',
    password: 'siasar',
    reports: {
      community: 'COM_Report.prpt',
      system: 'SYS_Report.prpt',
      serviceProvider: 'SP_Report.prpt',
      technicalProvider: 'TAP_Report.prpt',
    },
  },
};



// WEBPACK FOOTER //
// ./src/config.js